import { forwardRef } from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

import {
  DROPDOWN_MENU_ITEM_VARIANT_CLASS_MAP,
  type TDropdownMenuItemElement,
  type TDropdownMenuItemProps,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenu.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib/utils";

export const DropdownMenuItem = forwardRef<TDropdownMenuItemElement, TDropdownMenuItemProps>(
  (
    {
      children,
      className,
      icon,
      inset,
      variant = "default",
      ...props
    },
    ref,
  ) => (
    <DropdownMenuPrimitive.Item
      data-component="DropdownMenuItem"
      ref={ref}
      className={cn(
        "relative flex w-full cursor-default select-none items-center gap-2 rounded-sys-sm py-1.5 pr-2 outline-none transition-colors",
        icon || inset ? "pl-8" : "pl-2",
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        DROPDOWN_MENU_ITEM_VARIANT_CLASS_MAP[variant],
        className,
      )}
      {...props}
    >
      { icon ? (
        <span
          data-component="DropdownMenuItemIcon"
          className="absolute left-2 flex h-4 w-4 items-center justify-center"
        >
          <Icon icon={icon} aria-hidden="true" size="sm" />
        </span>
      ) : null }
      <TextBody tag="span" size={2} color="inherit" isResponsive={false}>
        { children }
      </TextBody>
    </DropdownMenuPrimitive.Item>
  ),
);

DropdownMenuItem.displayName = DropdownMenuPrimitive.Item.displayName;
